module.exports = __webpack_public_path__ + "static/img/B (34).fbcb2ebd.png";